<template>
    <div>
        <div class="chart-container">
            <canvas ref="activityChart"></canvas>
        </div>
        
        <p class="text-center" style="margin-top: 10px;">
            Activities Breakdown <br />
            Completed: {{ totalCompleted }} | Overdue: {{ totalIncomplete }}
        </p>
    </div>
</template>

<script>
import Chart from 'chart.js';

export default {
    name: 'MonthlyBarChart',
    props: {
        activities: {
            type: Array,
            required: true,
            default: () => ([])
        }
    },
    computed: {
        totalCompleted() {
            if (!this.activities || this.activities.length === 0) {
                return 0;
            }
            return this.activities.reduce((sum, data) => sum + data.completed, 0);
        },
        totalIncomplete() {
            if (!this.activities || this.activities.length === 0) {
                return 0;
            }
            return this.activities.reduce((sum, data) => sum + data.overdue, 0);
        }
    },
    mounted() {
        this.renderChart();
    },
    watch: {
        activities: {
            immediate: true,
            handler() {
                this.renderChart();
            }
        }
    },
    methods: {
        renderChart() {
            const ctx = this.$refs.activityChart?.getContext('2d');
            if (!ctx) return;

            // Destroy any existing chart to avoid duplication
            if (this.chart) {
                this.chart.destroy();
            }

            // Prepare data for the chart
            const months = this.activities.map(item => item.month);
            const overdueData = this.activities.map(item => item.overdue);
            const completedData = this.activities.map(item => item.completed);

            // Create the bar chart
            this.chart = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: months, // Month names as labels
                    datasets: [
                        {
                            label: 'Overdue Activities',
                            data: overdueData,
                            backgroundColor: '#FB7289', // Red for overdue
                            // borderColor: '#e57373',
                            borderWidth: 2
                        },
                        {
                            label: 'Completed Activities',
                            data: completedData,
                            backgroundColor: '#C1F1FD', // Green for completed
                            // borderColor: '#81c784',
                            borderWidth: 2
                        }
                    ]
                },
                options: {
                    responsive: true,
                    scales: {
                        y: {
                            beginAtZero: true,
                            ticks: {
                                stepSize: 1, // Adjust this for appropriate step size
                            }
                        }
                    },
                    tooltips: {
                        enabled: true,
                        mode: 'index',
                        callbacks: {
                            label: function (tooltipItem, data) {
                                const label = data.labels[tooltipItem.index] || '';
                                const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                                return `${label}: ${value}`;
                            }
                        }
                    },
                    legend: {
                        display: true,
                        position: 'top'
                    }
                }
            });
        }
    }
};
</script>

<style>
.chart-container {
    display: flex; /* Use flexbox for layout */
    align-items: center; /* Center align items vertically */
}

canvas {
    height: 300px;
    width: 600px; /* Increase width for better bar visibility */
}
</style>
